import { Box, Dialog, DialogContent, Stack, useTheme } from '@mui/material';
import React from 'react';
import { Button, Typography } from '@elements';

type Props = {
  isOpen: boolean;
  closeHandler: () => void;
  message?: string;
};

const DEFAULT_MESSAGE =
  'Билет возвращен, денежные средства поступят в течение 14 дней';

const RefundSuccessModal = ({
  isOpen,
  closeHandler,
  message = DEFAULT_MESSAGE,
}: Props) => {
  const theme = useTheme();

  return (
    <Dialog
      open={isOpen}
      onClose={closeHandler}
      aria-labelledby="refund-success-dialog"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          minWidth: { xs: '296px', md: '386px' },
          backgroundColor: theme.palette.mirage.main,
        },
      }}
    >
      <DialogContent
        sx={{
          backgroundColor: theme.palette.mirage.main,
          border: 0,
          px: '25px',
          py: '32px',
        }}
      >
        <Stack direction="column" spacing={3}>
          <Typography color="white" align="center" fontSize={22}>
            {message}
          </Typography>
          <Button
            variant="contained"
            color="internationalOrange"
            fullWidth
            size="large"
            onClick={closeHandler}
            sx={{ textTransform: 'uppercase', marginTop: '16px !important' }}
          >
            Понятно
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RefundSuccessModal;
